import { useAllowancesQuery } from '../api/query';
import type { Limit, Context } from '../types';

export function useLimit(limit: Limit, context: Context): number | null {
  const query = useAllowancesQuery(context);

  if (query.isSuccess) {
    return query.data.limits[limit];
  }

  return null;
}
